var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },

  {
    id: "approval_status",
    label: "承認状態",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved　// Shōnin sumi
      "申請中",  // Applying // Shinsei-chū
      "差戻",    // Rejected // Kyakka
      "承認完了"
    ],
    table_field_style:{
      "承認済":"color:;",
      "申請中":"color:blue;",
      "下書中":"color:#a0283a",
      "差戻":"color:red;"
    },
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "fk_id",
    label: "fk_id",
    type: types.INPUT,
  },
  {
    id: "tab_id",
    label: "tab_id",
    type: types.INPUT,
  },
  {
    id: "ref_id",
    label: "ref_id",
    type: types.INPUT,
  },
  {
    id: "syubetu",
    label: "種別",
    type: types.SELECT_BOX,
    options: ["機器・組込情報", "証書情報"],
    import: { enabled: true },
  },
  {
    id: "control_number",
    label: "管理番号",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "toroku_number",
    label: "申請No",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "bulk_toroku_number",
    label: "一括編集No",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant",
    label: "申請者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant_team",
    label: "申請者チーム",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "update_name",
    label: "最終更新者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "next_approver",
    label: "次回承認者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant_label",
    label: "申請者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "update_name_label",
    label: "最終更新者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "next_approver_label",
    label: "次回承認者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "create_time",
    label: "開始日時",
    type: types.CURRENT_TIME,
    import: { enabled: true },
  },
  {
    id: "update_time",
    label: "更新日時",
    type: types.CURRENT_TIME,
    import: { enabled: true },
  },
  {
    id: "licensed_department",
    label: "ライセンス所管部署",
    type: types.SELECT_BOX4,
    api:"/master_belongs/list_department",
    import: { enabled: true },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
  {
    id: "record_checked",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },

  {
    id: "status_0",
    label: "状態0",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_1",
    label: "所属チーム1",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_1_selected",
    api_uniq_grouping:true,
    import: { enabled: true }
  },
  {
    id: "approver_1",
    label: "承認者1",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_1",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_1_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_1",
      compare_api_key:"team",
      filter_data_on_event:"team_1_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_1",
    label: "状態1",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_2",
    label: "所属チーム2",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_2_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_1_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_2",
    label: "承認者2",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_2",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_2_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_2",
      compare_api_key:"team",
      filter_data_on_event:"team_2_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_2",
    label: "状態2",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_3",
    label: "所属チーム3",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_3_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_2_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_3",
    label: "承認者3",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_3",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_3_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_3",
      compare_api_key:"team",
      filter_data_on_event:"team_3_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_3",
    label: "状態3",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_4",
    label: "所属チーム4",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_4_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_3_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_4",
    label: "承認者4",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_4",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_4_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_4",
      compare_api_key:"team",
      filter_data_on_event:"team_4_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_4",
    label: "状態4",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_5",
    label: "所属チーム5",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_5_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_4_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_5",
    label: "承認者5",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_5",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_5_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_5",
      compare_api_key:"team",
      filter_data_on_event:"team_5_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_5",
    label: "状態5",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_6",
    label: "所属チーム6",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_6_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_5_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_6",
    label: "承認者6",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_6",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_6_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_6",
      compare_api_key:"team",
      filter_data_on_event:"team_6_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_6",
    label: "状態6",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_7",
    label: "所属チーム7",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_7_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_6_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_7",
    label: "承認者7",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_7",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_7_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_7",
      compare_api_key:"team",
      filter_data_on_event:"team_7_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_7",
    label: "状態7",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_8",
    label: "所属チーム8",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_8_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_7_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_8",
    label: "承認者8",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_8",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_8_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_8",
      compare_api_key:"team",
      filter_data_on_event:"team_8_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_8",
    label: "状態8",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_9",
    label: "所属チーム9",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_9_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_8_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_9",
    label: "承認者9",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_9",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_9_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_9",
      compare_api_key:"team",
      filter_data_on_event:"team_9_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_9",
    label: "状態9",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_10",
    label: "所属チーム10",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_10_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_9_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_10",
    label: "承認者10",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_10",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_10_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_10",
      compare_api_key:"team",
      filter_data_on_event:"team_10_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_10",
    label: "状態10",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_11",
    label: "所属チーム11",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_11_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_10_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_11",
    label: "承認者11",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_11",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_11_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_11",
      compare_api_key:"team",
      filter_data_on_event:"team_11_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_11",
    label: "状態11",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_12",
    label: "所属チーム12",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_12_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_11_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_12",
    label: "承認者12",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_12",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_12_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_12",
      compare_api_key:"team",
      filter_data_on_event:"team_12_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_12",
    label: "状態12",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_13",
    label: "所属チーム13",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_13_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_12_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_13",
    label: "承認者13",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_13",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_13_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_13",
      compare_api_key:"team",
      filter_data_on_event:"team_13_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_13",
    label: "状態13",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_14",
    label: "所属チーム14",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_14_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_13_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_14",
    label: "承認者14",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_14",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_14_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_14",
      compare_api_key:"team",
      filter_data_on_event:"team_14_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_14",
    label: "状態14",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_15",
    label: "所属チーム15",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_15_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_14_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_15",
    label: "承認者15",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_15",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_15_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_15",
      compare_api_key:"team",
      filter_data_on_event:"team_15_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_15",
    label: "状態15",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_16",
    label: "所属チーム16",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_16_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_15_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_16",
    label: "承認者16",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_16",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_16_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_16",
      compare_api_key:"team",
      filter_data_on_event:"team_16_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_16",
    label: "状態16",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_17",
    label: "所属チーム17",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_17_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_16_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_17",
    label: "承認者17",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_17",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_17_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_17",
      compare_api_key:"team",
      filter_data_on_event:"team_17_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_17",
    label: "状態17",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_18",
    label: "所属チーム18",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_18_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_17_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_18",
    label: "承認者18",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_18",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_18_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_18",
      compare_api_key:"team",
      filter_data_on_event:"team_18_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_18",
    label: "状態18",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_19",
    label: "所属チーム19",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_19_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_18_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_19",
    label: "承認者19",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_19",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_19_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_19",
      compare_api_key:"team",
      filter_data_on_event:"team_19_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_19",
    label: "状態19",
    type: types.INPUT,
    import: { enabled: true },
  },
 {
    id: "team_20",
    label: "所属チーム20",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_20_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_19_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_20",
    label: "承認者20",
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_20",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    // global_emit:"approver_20_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_20",
      compare_api_key:"team",
      filter_data_on_event:"team_20_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_20",
    label: "状態20",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "approver_final",
    label: "最終承認者",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    field_label_reference:"approver_label_final",
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    // api_filter_to_other_field:{
    //   by_field:"team_5",
    //   compare_api_key:"team",
    //   filter_data_on_event:"team_5_selected",
    // },
    import: { enabled: true },
  },
  {
    id: "status_final",
    label: "最終状態",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "approver_label_1",
    label: "承認者1",
    type: types.INPUT,
  },
  {
    id: "approver_label_2",
    label: "承認者2",
    type: types.INPUT,
  },
  {
    id: "approver_label_3",
    label: "承認者3",
    type: types.INPUT,
  },
  {
    id: "approver_label_4",
    label: "承認者4",
    type: types.INPUT,
  },
  {
    id: "approver_label_5",
    label: "承認者5",
    type: types.INPUT,
  },
  {
    id: "approver_label_6",
    label: "承認者6",
    type: types.INPUT,
  },
  {
    id: "approver_label_7",
    label: "承認者7",
    type: types.INPUT,
  },
  {
    id: "approver_label_8",
    label: "承認者8",
    type: types.INPUT,
  },
  {
    id: "approver_label_9",
    label: "承認者9",
    type: types.INPUT,
  },
  {
    id: "approver_label_10",
    label: "承認者10",
    type: types.INPUT,
  },
  {
    id: "approver_label_11",
    label: "承認者11",
    type: types.INPUT,
  },
  {
    id: "approver_label_12",
    label: "承認者12",
    type: types.INPUT,
  },
  {
    id: "approver_label_13",
    label: "承認者13",
    type: types.INPUT,
  },
  {
    id: "approver_label_14",
    label: "承認者14",
    type: types.INPUT,
  },
  {
    id: "approver_label_15",
    label: "承認者15",
    type: types.INPUT,
  },
  {
    id: "approver_label_16",
    label: "承認者16",
    type: types.INPUT,
  },
  {
    id: "approver_label_17",
    label: "承認者17",
    type: types.INPUT,
  },
  {
    id: "approver_label_18",
    label: "承認者18",
    type: types.INPUT,
  },
  {
    id: "approver_label_19",
    label: "承認者19",
    type: types.INPUT,
  },
  {
    id: "approver_label_20",
    label: "承認者20",
    type: types.INPUT,
  },
  {
    id: "approver_label_final",
    label: "最終承認者",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_approval_history_inventory.js